import { Box, Text } from 'grommet';
import { observer } from 'mobx-react-lite';
import { useEstimateStore } from '@talon/web/src/context';
import { tableHeaderTextProps } from '../../TableHeaderItem';

export const UsageEstimateTitleRow = observer(() => {
  /** Context **/
  const estimateStore = useEstimateStore();

  /** Render **/
  return (
    <Box
      direction="row"
      gap="medium"
      pad={{ vertical: 'small', horizontal: 'medium' }}
      border={{ side: 'bottom', color: 'border-card' }}
      background="surface-header"
    >
      <Box width="75%">
        <Text {...tableHeaderTextProps}>{estimateStore.canEditCurrent ? 'Performer type' : 'Role'}</Text>
      </Box>
      <Box fill="horizontal">
        <Text {...tableHeaderTextProps}>Usage type</Text>
      </Box>
      {/* Money and number columns are right-aligned, like their values */}
      <Box width="75%" align="end">
        <Text {...tableHeaderTextProps}>Units</Text>
      </Box>
      <Box width="75%" align="end">
        <Text {...tableHeaderTextProps}>Cycles</Text>
      </Box>
      <Box width="55%" align="end">
        <Text {...tableHeaderTextProps}>Rate</Text>
      </Box>
      <Box width="60%" align="end">
        <Text {...tableHeaderTextProps}>Subtotal</Text>
      </Box>
      <Box width="40%" align="end">
        <Text {...tableHeaderTextProps}>P&H</Text>
      </Box>
      <Box width="40%" align="end">
        <Text {...tableHeaderTextProps}>Handling</Text>
      </Box>
      <Box width="40%" align="end">
        <Text {...tableHeaderTextProps}>Taxes</Text>
      </Box>
      <Box width="70%" align="end">
        <Text {...tableHeaderTextProps}>Subtotal + fringe</Text>
      </Box>
      <Box width="40px" flex={false} />
    </Box>
  );
});
